import { slugify } from '../data/catalog';

export function buildAlertCtaUrl({ keyword, category, maxPrice, source = 'internal' }) {
    const params = new URLSearchParams();
    const cleanKeyword = String(keyword || '').trim().slice(0, 100);
    const cleanCategory = slugify(String(category || '').trim());
    const numericPrice = Number(maxPrice);

    if (cleanKeyword) params.set('alerta', cleanKeyword);
    if (cleanCategory) params.set('alertCategory', cleanCategory);
    if (Number.isFinite(numericPrice) && numericPrice > 0) {
        params.set('alertMaxPrice', numericPrice.toFixed(2));
    }
    params.set('utm_source', source);
    params.set('utm_medium', 'internal');
    params.set('utm_campaign', 'alert_cta');

    return `/?${params.toString()}#alertas`;
}

export default buildAlertCtaUrl;
